module.exports = __webpack_public_path__ + "img/guide-student3.f218bdbf.png";